<template>
  <aha-modal
    size="md"
    @hide="$emit('hide')"
    :title="titleYouCanOnlyView"
    class="be-taken-over-modal"
  >
    <p class="mb-2">
      {{ beTakenOverWhilepresenting ?
        $i18nPresenter.t('This person is now hosting the presentation:') :
        $i18nPresenter.t('This person has just taken over this presentation:') }}
    </p>
    <div class="flex items-center p-2 mb-3 bg-secondary-10">
      <aha-avatar
        class="mr-2 text-lg"
        :name="presenter.name"
        :image="presenter.avatar"
        :id="presenter.id"
        :width="36"
        :height="36"
      />
      <div class="flex flex-col">
        <span class="font-bold">
          <strong>{{ presenter.name }}</strong>
        </span>
        <p>{{ presenter.email }}</p>
      </div>
    </div>
    <p>{{ $i18nPresenter.t('Only they can now edit this presentation.') }}</p>
    <template #action>
      <aha-button
        @click="$emit('hide')"
      >
        {{ $i18nPresenter.t('OK, I understand') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  props: {
    presenter: {
      type: Object,
      default() {
        return {}
      },
    },
    beTakenOverWhilepresenting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      titleYouCanOnlyView: this.$i18nPresenter.t('You can only now view this presentation'),
    }
  },
}
</script>

<style lang="scss" scoped>
.be-taken-over-modal {
  ::v-deep .aha-modal-content {
    width: 28rem;
  }
}
</style>
